import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { buildGoogleDataUse } from '../../data/googleDataUse';
import './GoogleDataUse.css';

/**
 * «Cómo usa InvokeApp tu cuenta de Google» en la home. Lo pide la verificación de Google
 * (la home explica por qué la app pide datos de Google y enlaza la política de privacidad).
 *
 * El texto vive en src/data/googleDataUse.js, junto con los interruptores CLAIMS: una frase
 * que dependa de un control aún no desplegado no se publica hasta que el control está en
 * producción. Lleva id="google-data" para poder enlazar la sección.
 */
const GoogleDataUse = () => {
  const { i18n } = useTranslation();
  const content = buildGoogleDataUse(i18n && i18n.language ? i18n.language : 'es');

  return (
    <section
      id="google-data"
      className="google-data-use__area"
      aria-labelledby="google-data-title"
      lang={content.lang}
    >
      <div className="container">
        <div className="google-data-use">
          <span className="google-data-use__kicker">{content.kicker}</span>
          <h2 id="google-data-title" className="google-data-use__title">{content.title}</h2>
          <p className="google-data-use__intro">{content.intro}</p>

          <ul className="google-data-use__list">
            {content.items.map((item) => (
              <li key={item.key} className="google-data-use__item" data-testid={`google-data-${item.key}`}>
                <h3 className="google-data-use__item-title">
                  {item.title}
                  {item.scope && <code className="google-data-use__scope">{item.scope}</code>}
                </h3>
                <p className="google-data-use__item-text">{item.text}</p>
              </li>
            ))}
          </ul>

          <p className="google-data-use__limited">
            {content.limitedUse}{' '}
            <a href={content.limitedUseUrl} target="_blank" rel="noopener noreferrer">
              {content.limitedUseLink}
            </a>
          </p>

          <Link className="google-data-use__privacy" to={content.privacyPath}>
            {content.privacyLink}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GoogleDataUse;
